import { render, staticRenderFns } from "./NRWFreistellung.vue?vue&type=template&id=243b16ba&"
import script from "./NRWFreistellung.vue?vue&type=script&lang=js&"
export * from "./NRWFreistellung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports